import type React from "react";
import { memo } from "react";
import cx from "classnames";

interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
}

const CardTitle = ({ children, className }: CardTitleProps) => (
  <h2 className={cx("text-sm color-primary", className)}>{children}</h2>
);

const MemoedCardTitle = memo(CardTitle);
MemoedCardTitle.displayName = "CardTitle";

export default MemoedCardTitle;
